// extracted by mini-css-extract-plugin
module.exports = {"text":"payload-condition_text__2RlQS","titleListAttach":"payload-condition_titleListAttach__368NK"};